import type { CommonTranslations } from "./commonTranslations.types"

const commonEnTranslations: CommonTranslations = {
  "validate": "Validate",
  "send": "Send",
  "understand": "I understand",
  "ok": "OK",
  "reload": "Reload",
  "packageTransferIncluded": "With all our packages, the transfer from your arrival point to your resort is included",
  "confirmation": {
    "confirmationErrorPopupPhone": "0800 260 5082",
    "confirmationStatusReservationTitle": "Congratulations",
    "confirmationStatusReservationSubtitle1": "Your holiday begins in",
    "confirmationStatusReservationSubtitle2": "days",
    "confirmationReservation1": "You will receive the confirmation of your booking and payment in a few minutes",
    "confirmationReservation2": "As a reminder, we will take payment today of",
    "confirmationReservation3": "corresponding to",
    "confirmationReservation4": "% of the amount of your booking.",
    "confirmationReservation5": "The balance of your booking is",
    "confirmationReservation6": "which will be automatically taken",
    "confirmationReservation7": ".",
    "confirmationReservation8": "You can find all the details on your Travelski account. You can login",
    "confirmationReservation9": "here",
    "confirmationReservation10": ".",
    "confirmationByPhone": "Call an expert",
    "confirmationBooking100Percent1": "You will receive within a few minutes the confirmation of your stay and that of your payment.",
    "confirmationBooking100Percent2": "For your reminder, we proceed today with the debit of",
    "confirmationBooking100Percent3": ", corresponding to 100% of the amount of your stay.",
    "confirmationBooking100Percent4": "Find all this information on your Travelski account. You can connect",
    "confirmationBooking100Percent5": "here",
    "confirmationBooking100Percent6": ".",
    "confirmationStatusReservationTitleAlreadyPaid": "Your stay has already been paid.",
    "confirmationStatusQuoteTitle": "Your search is saved",
    "confirmationStatusQuoteSubtitle": "Remember to complete your reservation",
    "confirmationQuote1": "Travelski thanks you for your trust and is pleased to confirm that your search is saved.",
    "confirmationQuote2": "Reference:",
    "widgetCartSuccessTitle": "The train order was registered",
    "widgetSuccessTitle": "Booking confirmed!",
    "widgetSuccessTicketsEmail": "Thank you for your purchase. You will receive your tickets within a few minutes at:",
    "widgetCartSuccessInfo": "Your order has been registered. You will receive your tickets at:",
    "widgetSuccessBackToSite": "Return to site",
    "confirmationQuote3": "The search saved is not a booking or a reservation. Only when you pay a deposit or the full balance can we confirm the availability of the request.",
    "confirmationReserveQuick": "Book now!",
    "confirmationStatusErrorTitle": "An error has ocurred",
    "confirmationError1": "We are sorry that your booking could not be confirmed. Do try again or contact us on",
    "confirmationOtherPaymentMethod": "0800 260 5082",
    "confirmationError1Sentence": "Unfortunately, your stay reservation could not be processed",
    "confirmationUnavailableText": "Your requested accomodation is unfortunately no longer available. Please try again or contact us on",
    "confirmationErrorText": "Sorry, but your payment has been declined. Please try again or contact us on",
    "confirmationErrorPhone": "0800 260 5082",
    "confirmationErrorPhoneYoonly": "+32 2 808 25 70",
    "confirmationMakeReservationAccountTitle": "My account",
    "confirmationMakeReservationAccount": "Log in to the \"My Account\" section to find your search and much more",
    "confirmationMakeReservationAccountButton": "Go to my account",
    "confirmationMakeReservationPhoneTitle": "by phone",
    "confirmationMakeReservationPhone1": "Call one of our holiday advisors on",
    "confirmationMakeReservationPhone2": "0800 260 5082",
    "confirmationStatusUnavailableTitle": "This accommodation is no longer available",
    "confirmationStatusUnavailableSubtitle": "We are sorry but the holiday you selected is no longer available.",
    "confirmationUnavailable1": "The holiday you selected is no longer available as it has just been booked by another customer.",
    "confirmationUnavailable2": "You have not been charged",
    "confirmationFindAnother": "Find another holiday",
    "confirmationFindAnotherSameTitle": "Keep the same accommodation",
    "confirmationFindAnotherSame1": "This is your preferred accommodation and you are flexible? Change the travel dates or select another room.",
    "confirmationFindAnotherSameButton": "Return to the accommodation page",
    "confirmationFindAnotherOtherTitle": "Stay in the same resort",
    "confirmationFindAnotherOther1": "This resort is popular, but we are confident you will love it.",
    "confirmationFindAnotherOtherButton": "Our other options are",
    "confirmationFindAnotherSearchTitle": "Search again",
    "confirmationFindAnotherSearch1": "Despite our best efforts, you do not want to continue your serach at this resort.",
    "confirmationFindAnotherSearch2": "No problem, Travelski offer options across 160 resorts.",
    "confirmationFindAnotherSearchButton": "Search again",
    "confirmationFindAnotherQuestionTitle": "Have a question? Have a problem?",
    "confirmationFindAnotherQuestion1": "0800 260 5082",
    "confirmationYourOrder": "Your order",
    "confirmationSummaryDetailsButton": "Details of my order",
    "confirmationAccessAccount": "Go to my account"
  },
  "contacts": {
    "logInOrRegister": "Log-in or register to book",
    "loginRegister": "Login / Register",
    "login": "Login",
    "emailNotValid": "Continue",
    "errorWrongEmail": "The entered email address is invalid. Please check the details and try again.",
    "contactsFirstName": "1st name",
    "contactsLastName": "Surname",
    "contactsEmail": "Email",
    "contactsOtherEmail": "Sign in with another email",
    "contactsPassword1": "Password",
    "contactsPassword2": "Confirm your password",
    "contactsPasswordFormat": "Your passowrd must",
    "contactsPasswordFormatLenght": "contain a minimum of 8 characters",
    "contactsPasswordFormatLowercase": "contain at least 1 lowercase character",
    "contactsPasswordFormatUppercase": "contain at least 1 uppercase character",
    "contactsPasswordFormatNumber": "contain at least one number",
    "contactsPasswordFormatCharacter": "conatin at least one special character",
    "contactsPasswordsDontMatch": "The password does not match",
    "contactsEmailIsNotValid": "The email is not valid",
    "contactsAddress": "Address",
    "contactsCity": "City",
    "contactsCountry": "Country",
    "contactsPostalCode": "Postcode",
    "contactsPhoneNumber": "Phone number",
    "contactsSubscribeNewsletter": "I subscribe to the Travelski.com newsletter and take advantage of promotions, flash sales, and loyalty benefits!",
    "contactsAcceptConditions1": "I have read and accept the",
    "contactsAcceptConditions2": "General Terms and Conditions",
    "contactsAcceptConditions3": "and I acknowledge that there is no right of withdrawal.",
    "contactsAcceptConditions4": "",
    "contactsIncorrectCredentials": "Your credentials are incorrect"
  },
  "continue": {
    "continueWithTheseContacts": "Continue with these details",
    "continue": "Continue"
  },
  "user": {
    "title": 'Coordinates',
    "userInfoMandatoryField": "Required field",
    "userInfoInvalidPhone": "Invalid Phone number format. Phone number must contain 11 numbers and start by 0.",
    "userInfoInvalidPhoneLength": "Invalid format. Phone number must contain 11 numbers.",
    "userInfoForgotPassword": "Forgot my password",
    "userInfoAlreadyHaveAccount": "Already have an account",
    "userInfoEnterEmail": "Reset your password",
    "userInfoEmailSent": "We have sent a link to reset your password to",
    "userInfoNewPassword": "Enter your new password",
    "userInfoYourInformations": "Your information",
    "userInfoEmail": "Email",
    "userInfoPhone": "Phone",
    "userInfoContactHint": "We use your contact details to send your booking documents.",
    "userInfoToContactYou": "To contact you",
    "userInfoLiheMoreDetails": "More details",
    "userInfoCreateAccount": "Create an account",
    "userInfoIsItFirstTime": "Are you travelling with Travelski for the first time?",
    "newPasswordForgotPassword": "Forgotten password",
    "newPasswordCreateNewPassword": "Create your new password",
    "newPassword1": "New password",
    "newPassword2": "Confirm your new password",
    "invalidToken": "The token has expired. Please try again.",
    "newPasswordSucces": "Your password has been changed successfully",
  },
  "sessionExpired": "Your session is about to expire. Please click here to continue.",
  "paymentChanged": "The amount of your booking has changed.<br>You have not been charged.<br>Please check your booking and enter your credit card details again.",
  "flightError": "Your selected flight is no longer available. Please choose another flight."
}

export default commonEnTranslations;
